var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0439 15.732C22.0439 19.31 19.9349 21.419 16.3569 21.419H8.5749C4.9879 21.419 2.8749 19.31 2.8749 15.732V7.932C2.8749 4.359 4.1889 2.25 7.7679 2.25H9.7679C10.4859 2.251 11.1619 2.588 11.5919 3.163L12.5049 4.377C12.9369 4.951 13.6129 5.289 14.3309 5.29H17.1609C20.7479 5.29 22.0719 7.116 22.0719 10.767L22.0439 15.732Z",
    fill: "url(#paint0_linear_35428_1145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.106 14.4629H16.841",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35428_1145",
    x1: -3.48103,
    y1: 50.472,
    x2: 23.2214,
    y2: 50.3444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderActive);
export default __webpack_public_path__ + "static/media/folder-active.bb8061cdd59263dbfbed40b4cc098695.svg";
export { ForwardRef as ReactComponent };